const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const OfficeModal = require("./OfficeModal");
const withVaultDispatch = require("../../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../../core/hoc/withVaultUpdate");
const AT = require("../../core/vault/ActionTypes");
const CopyTable = require("../data/CopyTable");
const Link = require("../../core/view/Link");
const UserRateLimitModal = require("./UserRateLimitModal");
const URLMake = require("../../../shared/URLMake");
const AssetsUtil = require("../../core/util/AssetsUtil");

const styles = require("./styles/MessageModal.css");

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "MessageModal",

		propTypes: {
			// Injected by HOCs
			dispatch: PT.func.isRequired,
		},

		// Used by vault update HOC
		vaultEvents: {
			showOfficeModal: function(messageType, extraInfo) {
				this.setState({isOpen: true, messageType, extraInfo});
			},
		},

		getInitialState: function() {
			return {
				isOpen: false,
				messageType: "",
			};
		},

		onClose: function() {
			this.setState({isOpen: false});
		},

		goToContact: function() {
			this.props.dispatch({
				type: AT.SET_PAGE,
				pageState: URLMake.state.forContactReason("orders"),
				addToHistory: true,
			});
			this.onClose();
		},

		logout: function() {
			this.onClose();
			this.props.dispatch({
				type: AT.LOGOUT_USER_REQUEST,
			});
		},

		switch: function() {
			this.logout();
			this.props.dispatch({
				type: AT.START_OFFICE_LOGIN,
			});
		},

		onlyBooks: function() {
			this.onClose();
			this.props.dispatch({
				type: AT.REMOVE_SUBSCRIPTIONS_FROM_CART,
			});
		},

		renderWarningIcon: function() {
			return (
				<img
					className={styles.icon}
					alt=""
					src={AssetsUtil.getOfficeIcon("warning-icon")}
				/>
			);
		},

		render: function() {
			if (this.state.isOpen) {
				const type = this.state.messageType;
				const extraInfo = this.state.extraInfo || {};
				const displayName = extraInfo.displayName;
				const linkClickAction = () => this.onClose();
				const Copy = CopyTable.getMessageModalCopy(
					styles,
					linkClickAction,
					extraInfo
				);

				const studentBackground = (
					<div className={styles.playOuter}>
						<img
							className={styles.playLeft}
							alt=""
							src={AssetsUtil.getLoginCharacters("left")}
						/>
						<img
							className={styles.playRight}
							alt=""
							src={AssetsUtil.getLoginCharacters("right")}
						/>
					</div>
				);
				let button = (
					<div className={styles.button} onClick={this.onClose}>
						Okay
					</div>
				);
				let mainClass = styles.main;
				const containerClass = styles.container;
				let content = null;
				let background = null;
				let aboveContent = null;
				let modalTitle = null;

				let closeOnEsc = true;
				let closeOnBackdropClick = true;
				let cannotClose = false;

				if (type === "policyNotification") {
					const policyType = extraInfo.type;
					const policyModalNotifications =
						CopyTable.getPolicyModalNotifications()[policyType] || {};
					modalTitle = policyModalNotifications.title ? (
						<div className={styles.modalTitle}>
							{policyModalNotifications.title}
						</div>
					) : null;
					content = policyModalNotifications.content ? (
						<div className={styles.paragraphLeftLarger}>
							{policyModalNotifications.content}
						</div>
					) : null;
					background = null;
					button = null;
				} else if (type === "mustSignout") {
					closeOnEsc = false;
					closeOnBackdropClick = false;
					cannotClose = true;

					mainClass = styles.noDefaultHeight;
					content = <div className={styles.text}>{Copy[type]}</div>;
					button = (
						<div className={styles.buttonsStack}>
							<Link
								to={URLMake.forSignout({
									requestedURL: window.location.pathname,
								})}
								isExternal={true}
								className={styles.button}
								clickAction={this.onClose}
								noFocus={true}
							>
								{"Sign Out"}
							</Link>
						</div>
					);
				} else if (type === "tooManyRequests") {
					aboveContent = this.renderWarningIcon();
					content = <div className={styles.text}>{Copy.tooManyRequests}</div>;
				} else if (type === "userRateLimit") {
					return <UserRateLimitModal initialSeconds={30} />;
				} else if (type === "student") {
					modalTitle = (
						<div className={styles.modalTitle}>Play Beast Academy Online</div>
					);
					aboveContent = (
						<div className={styles.studentInfo}>
							You are signed in as {displayName}.<br />
							<br />
							Would you like to play
							<br />
							Beast Academy Online?
						</div>
					);
					content = (
						<div className={styles.buttonsOuter}>
							<Link
								to={URLMake.forHome()}
								className={styles.button}
								noFocus={true}
							>
								{"Play"}
							</Link>
							<div className={styles.button} onClick={this.logout}>
								Sign out
							</div>
						</div>
					);
					background = studentBackground;
					button = null;
				} else if (type === "studentDeactivated") {
					modalTitle = (
						<div className={styles.modalTitle}>Subscription Inactive</div>
					);
					aboveContent = (
						<div className={styles.studentInfo}>
							You are signed in as {displayName}.<br />
							<br />
							Your subscription is currently inactive.
							<br />
							Please contact your parent or administrator.
						</div>
					);
					content = (
						<div className={styles.buttonsOuter}>
							<div className={styles.button} onClick={this.logout}>
								Sign Out
							</div>
						</div>
					);
					button = null;
					background = studentBackground;
				} else if (type === "switchAccount") {
					aboveContent = (
						<div className={styles.text}>
							{"You are signed in as " + displayName + "."}
							<br />
							{Copy.badPermissions}
						</div>
					);
					const homePage = extraInfo.suggestedPage;
					const isPlay = homePage.name === "home.main";
					content = (
						<div className={styles.buttonsOuter}>
							<div className={styles.button} onClick={this.switch}>
								Switch Accounts
							</div>
							<Link
								to={URLMake.forPageState(homePage)}
								clickAction={this.onClose}
								className={styles.button}
								noFocus={true}
							>
								{isPlay ? "Play" : "Home"}
							</Link>
						</div>
					);
					background = isPlay ? studentBackground : null;
					button = null;
				} else if (type === "subsThruAccount") {
					const isParent = extraInfo.role === "parent"; // "parent" or "other"
					if (!isParent) {
						//Only make it scary for  non-parents since they shouldn't get here.
						aboveContent = this.renderWarningIcon();
					}
					content = (
						<div className={styles.text}>
							{isParent ? Copy.subsThruAccountOnly : Copy.cannotBuySubs}
						</div>
					);
					if (isParent) {
						const onlyBooks = extraInfo.hasBooks ? (
							<div className={styles.button} onClick={this.onlyBooks}>
								Continue with Only Books
							</div>
						) : null;
						button = (
							<div className={styles.buttonsStack}>
								<Link
									to={URLMake.forAccount()}
									className={styles.button}
									clickAction={this.onClose}
									noFocus={true}
								>
									{"Go to Account"}
								</Link>
								{onlyBooks}
							</div>
						);
					}
				} else if (type === "PO") {
					aboveContent = this.renderWarningIcon();
					content = (
						<div>
							<div className={styles.text}>{Copy.tooManyItemsAddedToCart}</div>
							<div className={styles.link} onClick={this.goToContact}>
								{Copy.contactUsLink}
							</div>
						</div>
					);
				} else if (type === "noItems") {
					aboveContent = this.renderWarningIcon();
					content = (
						<div className={styles.text}>{Copy.noItemsAddedToCart}</div>
					);
				} else if (type === "cancelReasonSuccess") {
					content = (
						<div className={styles.textSmaller}>{Copy.cancelReasonSuccess}</div>
					);
				} else if (type === "noOwnerBilling") {
					aboveContent = this.renderWarningIcon();
					content = (
						<div className={styles.textThinner}>{Copy.noOwnerBilling}</div>
					);
					button = (
						<Link
							to={URLMake.forAccount("information", "billing")}
							className={styles.button}
							clickAction={this.onClose}
							noFocus={true}
						>
							{"Add Billing Address"}
						</Link>
					);
				} else if (type === "noOwnerPayment") {
					aboveContent = this.renderWarningIcon();
					content = (
						<div className={styles.textThinner}>{Copy.noOwnerPayment}</div>
					);
					button = (
						<Link
							to={URLMake.forAccount("information", "paymentMethod")}
							className={styles.button}
							clickAction={this.onClose}
							noFocus={true}
						>
							{"Add Payment Method"}
						</Link>
					);
				} else if (type === "ownerAddHitLimit") {
					aboveContent = this.renderWarningIcon();
					content = <div className={styles.text}>{Copy.ownerAddHitLimit}</div>;
				} else if (type === "ownerReactivateHitLimit") {
					aboveContent = this.renderWarningIcon();
					content = (
						<div className={styles.text}>{Copy.ownerReactivateHitLimit}</div>
					);
				} else if (type === "noOwnerSwitchWhileFailed") {
					aboveContent = this.renderWarningIcon();
					content = (
						<div className={styles.textEvenSmaller}>
							{Copy.noOwnerSwitchWhileFailed}
						</div>
					);
				} else if (type === "couponInfo") {
					mainClass = styles.larger;
					button = null;
					content = Copy[type];
				} else if (type === "redesignNotification") {
					button = null;
					content = Copy[type];
				} else if (type === "leaderboardsNotification") {
					button = null;
					content = Copy[type];
				} else {
					aboveContent = this.renderWarningIcon();
					content = (
						<div>
							<div className={styles.text}>{Copy[type]}</div>
						</div>
					);
				}
				return (
					<OfficeModal
						onClose={this.onClose}
						closeOnEsc={closeOnEsc}
						closeOnBackdropClick={closeOnBackdropClick}
						portalContainer={null}
						level="overBar"
						modalClass={mainClass}
						cannotClose={cannotClose}
					>
						{background}
						<div className={containerClass}>
							{modalTitle}
							<div className={styles.aboveButton}>
								{aboveContent}
								{content}
							</div>
							{button}
						</div>
					</OfficeModal>
				);
			} else {
				return null;
			}
		},
	})
);
